import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios, { CancelToken } from "axios";
import { useTranslation } from "react-i18next";

import { StatusCode } from "api/protocols";
import { GetDiscount } from "api/rpc/2024-04/facilityAdmin/discount/discount";
// import { IDiscount } from "api/rpc/2022-09/facilityAdmin/product/discount";

import { showError } from "redux/actions/ui";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { displayCurrency } from "helpers/Helpers";

import Page from "components/page/Page";
import { Badge } from "components/badge/Badge";
import DataTable from "../../../../../components/dataTable/DataTable";
import { IDiscount } from "api/rpc/2024-04/facilityAdmin/product/discount";

export default function Discounts() {
  const history = useHistory();
  const { t } = useTranslation();

  const authStore = useAppSelector(store => store.authStore);
  const dispatch = useAppDispatch();

  const [discounts, setDiscounts] = useState<IDiscount[]>(undefined);

  useEffect(() => {
    const source = axios.CancelToken.source();
    void loadLineItemDiscounts(source.token);
    return () => source.cancel();
  }, []);

  async function loadLineItemDiscounts(token?: CancelToken) {
    const res = await GetDiscount({ application: "line_item" }, false, token);

    if (token && token.reason) {
      return;
    }
    if (res.status !== StatusCode.OK) {
      dispatch(showError(t("Failed to load discounts")));
    }

    setDiscounts(res.status !== StatusCode.OK ? [] : res.data);
  }

  const primaryAction = {
    content: t("New Discount"),
    action: () => history.push("/admin/settings/discount/new"),
    disabled: !authStore.user?.permissions.discounts_create,
  };

  return (
    <Page
      title={t("Discounts")}
      subtitle={t("Create and edit discounts available in your point of sale")}
      narrow
      primaryAction={primaryAction}
    >
      <DataTable
        columns={[
          { label: t("Title"), width: "75%" },
          { label: t("Value"), width: "12.5%" },
          { label: "", width: "12.5%" }, // discount.custom
        ]}
        loading={discounts === undefined}
      >
        {discounts?.map(discount => (
          <tr
            key={discount.id}
            className="clickable"
            onClick={() => history.push(`/admin/settings/discount/${discount.id}`)}
          >
            <td>{discount.title}</td>
            <td>
              {discount.value_type === "percent" || discount.value_type === "cost_plus_percent"
                ? String(discount.value) + "%"
                : displayCurrency("cad", discount.value)}
            </td>
            <td>
              {discount.custom ? (
                <Badge size="small" type="success">
                  {t("Custom")}
                </Badge>
              ) : null}

              {discount?.auto_apply ? (
                <Badge size="small" type="success">
                  {t("Auto Applied")}
                </Badge>
              ) : null}
            </td>
          </tr>
        ))}
      </DataTable>
    </Page>
  );
}
